module.exports = __webpack_public_path__ + "static/media/warning_yellow.3118c3b9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/icons/warning_yellow.svg
// module id = 1070
// module chunks = 0